export default __webpack_public_path__ + "static/contact-buyer-message-preview-1d3f812644041f327d2a50c838fe3201.png";